export const containderId = window.CONTAINER_ID;
export const rootNode = document.getElementById(containderId);
